import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [busy, setBusy]   = useState(false);

  const handleSub = async e => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try { const r = await api.post('/newsletter', { email }); toast.success(r.message || 'Subscribed!'); setEmail(''); }
    catch (err) { toast.error(err.message); }
    finally { setBusy(false); }
  };

  const footLink = { color: 'rgba(255,255,255,0.5)', fontSize: 13, textDecoration: 'none', display: 'block', marginBottom: 9 };

  return (
    <footer style={{ fontFamily: "'Jost',sans-serif" }}>
      {/* Newsletter */}
      <div style={{ background: '#7a1f1f', padding: '52px 0' }}>
        <div className="container">
          <div className="footer-nl" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 32, flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#e8c96a', marginBottom: 6 }}>Join Our Community</div>
              <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 'clamp(1.4rem,2.5vw,2rem)', color: '#fff', fontStyle: 'italic', marginBottom: 6 }}>Stories in Every Thread</h3>
              <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13 }}>Exclusive collections, weaving stories & artisan spotlights.</p>
            </div>
            <form onSubmit={handleSub} style={{ display: 'flex', gap: 10, flex: 1, maxWidth: 440, minWidth: 240 }}>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="Your email address" style={{ flex: 1, padding: '12px 16px', border: 'none', background: 'rgba(255,255,255,0.14)', color: '#fff', fontSize: 14, outline: 'none' }} />
              <button type="submit" className="btn btn-gold" disabled={busy} style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>{busy ? '...' : 'Subscribe'}</button>
            </form>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div style={{ background: '#1a0f0f', padding: '60px 0 0' }}>
        <div className="container">
          <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1.2fr 1.5fr', gap: 40, marginBottom: 48 }}>
            {/* Brand */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                <span style={{ fontSize: 28 }}>🥻</span>
                <div>
                  <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, color: '#fff', lineHeight: 1 }}>Venkatagiri</div>
                  <div style={{ fontSize: 9, letterSpacing: '4px', color: '#c9a84c', textTransform: 'uppercase' }}>Handlooms</div>
                </div>
              </div>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, lineHeight: 1.8, marginBottom: 18 }}>Preserving the ancient art of Venkatagiri handloom weaving since 1985. Every saree is a testament to centuries of craftsmanship.</p>
              <div style={{ marginBottom: 18 }}>
                {['💳 Cards', '📱 UPI', '🏦 Net Banking', '📦 COD'].map(p => <span key={p} style={{ display: 'inline-block', background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.6)', padding: '3px 9px', fontSize: 10, border: '1px solid rgba(255,255,255,0.1)', marginRight: 6, marginBottom: 6 }}>{p}</span>)}
              </div>
            </div>
            {/* Collections */}
            <div>
              <h4 style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#c9a84c', marginBottom: 14 }}>Collections</h4>
              {[['/collections/silk-sarees','Silk Sarees'],['/collections/cotton-sarees','Cotton Sarees'],['/collections/wedding','Wedding Collection'],['/collections/jari-sarees','Zari / Jari Work'],['/collections/ikat','Ikat Collection'],['/collections/festival','Festival Special']].map(([to,l]) => <Link key={to} to={to} style={footLink}>{l}</Link>)}
            </div>
            {/* Account */}
            <div>
              <h4 style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#c9a84c', marginBottom: 14 }}>My Account</h4>
              {[['/login','Login / Register'],['/orders','Track Orders'],['/videos','Our Videos'],['/instagram','Instagram'],['/wishlist','Wishlist'],['/account','Profile']].map(([to,l]) => <Link key={to} to={to} style={footLink}>{l}</Link>)}
              <h4 style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#c9a84c', marginBottom: 14, marginTop: 20 }}>Help</h4>
              {[['#','Shipping Policy'],['#','Returns & Exchange'],['#','Care Instructions'],['#','FAQ']].map(([to,l]) => <a key={l} href={to} style={footLink}>{l}</a>)}
            </div>
            {/* Contact */}
            <div>
              <h4 style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#c9a84c', marginBottom: 14 }}>Contact Us</h4>
              {['📍 Venkatagiri, Nellore Dist.\nAndhra Pradesh — 524132','📞 +91 99636 86116','✉️ care@venkatagirihandlooms.com','⏰ Mon–Sat: 9AM–7PM IST'].map(line => (
                <div key={line} style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12, marginBottom: 12, lineHeight: 1.7 }}>
                  {line.split('\n').map((l,i) => <span key={i} style={{ display: 'block' }}>{l}</span>)}
                </div>
              ))}
              {/* WhatsApp CTA */}
              <a href="https://wa.me/919963686116" target="_blank" rel="noopener noreferrer"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginTop: 8, background: '#25D366', color: '#fff', padding: '9px 18px', fontSize: 12, fontWeight: 600, textDecoration: 'none' }}>
                💬 WhatsApp Us
              </a>
            </div>
          </div>
          {/* Bottom */}
          <div style={{ borderTop: '1px solid rgba(255,255,255,0.09)', padding: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
            <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11 }}>© 2024 Venkatagiri Handlooms. Made with ❤️ in Andhra Pradesh</div>
            <div style={{ display: 'flex', gap: 20 }}>
              {['Privacy Policy', 'Terms of Service', 'GI Certified'].map(l => <a key={l} href="#" style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11, textDecoration: 'none' }}>{l}</a>)}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
